/*
 * @Author: 曹捷
 * @Date: 2020-08-11 10:35:41
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-11-09 16:48:41
 * @Description: file content
 * mainApp 主APP
 */
import layoutMain from '@/layout/layout.vue'
export default [
    {
        path: '/',
        redirect: '/main/home',
    },
    {
        path: '/main/home',
        name: 'home',
        meta: { mainApp: true, headMenu: false },
        component: () => import('./../../views/home.vue')
    },
    {
        path: '/login',
        name: 'login',
        meta: { noLogin: true, fullPage: true },
        component: () => import('./../../views/login/login.vue')
    },
    {
        path: '/main/set/myserver',
        name: 'myserver',
        meta: { mainApp: true, name: '我的服务' },
        component: () => import('./../../views/sys/myserver/myserverIndex.vue')
    },
    {
        path: '/main/set/user',
        name: 'user',
        meta: { mainApp: true, name: '用户管理' },
        component: () => import('./../../views/sys/user/userIndex.vue')
    },
    {
        path: '/main/set/org',
        name: 'org',
        meta: { mainApp: true, name: '组织机构' },
        component: () => import('./../../views/sys/org/orgIndex.vue')
    },
    {
        path: '/main/set/role',
        name: 'role',
        meta: { mainApp: true, name: '角色管理' },
        component: () => import('./../../views/sys/role/roleIndex.vue')
    },
    {
        path: '/',
        component: layoutMain,
        children: [
            {
                path: '401',
                name: '401',
                meta: { noLogin: true, fullPage: true },
                component: () => import('./../../views/401.vue')
            },
            {
                path: '404',
                name: '404',
                meta: { noLogin: true, fullPage: true },
                component: () => import('./../../views/404.vue')
            }
        ]
    }
]